export default __webpack_public_path__ + "static/media/carrot_salad.ac29d106.jpg";